var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiVkFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39 6.39C4.5 8.298 4.5 11.349 4.5 17.46V18.54C4.5 24.642 4.5 27.693 6.39 29.61C8.298 31.5 11.349 31.5 17.46 31.5H18.54C24.642 31.5 27.693 31.5 29.61 29.61C31.5 27.702 31.5 24.651 31.5 18.54V17.46C31.5 11.358 31.5 8.307 29.61 6.39C27.702 4.5 24.651 4.5 18.54 4.5H17.46C11.358 4.5 8.307 4.5 6.39 6.39ZM9.054 12.717H12.15C12.249 17.865 14.517 20.043 16.317 20.493V12.717H19.224V17.154C20.997 16.965 22.869 14.94 23.499 12.708H26.397C26.1608 13.8634 25.6888 14.9577 25.0105 15.9225C24.3323 16.8872 23.4623 17.7017 22.455 18.315C23.5792 18.8743 24.5719 19.6656 25.3678 20.6368C26.1636 21.608 26.7445 22.7369 27.072 23.949H23.877C23.193 21.816 21.483 20.16 19.224 19.935V23.949H18.864C12.708 23.949 9.198 19.737 9.054 12.717Z",
    fill: "#0D3754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiVkFill);
export default __webpack_public_path__ + "static/media/ri_vk-fill.919516007643107116a7c52799077dcf.svg";
export { ForwardRef as ReactComponent };